import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { PASSWORD_STRENGTH } from 'common/helpers/valdiation';
import styles from './PasswordStrengthMeter.module.scss';

type Props = {
  passwordStrength?: PASSWORD_STRENGTH;
}

const cx = classNames.bind(styles);

const PasswordStrengthMeter = ({ passwordStrength }: Props) => {
  const progressStyle = cx({
    progress: true,
    weak: passwordStrength === PASSWORD_STRENGTH.WEAK,
    fair: passwordStrength === PASSWORD_STRENGTH.FAIR,
    strong: passwordStrength === PASSWORD_STRENGTH.STRONG,
  });

  return (
    <div className={styles.bar}>
      <div className={progressStyle} />
    </div>
  )
}

export default PasswordStrengthMeter